import { NgModule } from '@angular/core';

import { FilterPipe } from '../pipes/filter.pipe';
import { NumberInputLegacyDirective } from '@directives/number-input-legacy.directive';
import { ObserverIntersectionDirective } from '@directives/observer-intersection.directive';
import { NumberInputQtyLegacyDirective } from '@directives/number-input-qty-legacy.directive';
import { FilterBrandVariantPipe } from '../pipes/filter-brand-variant.pipe';
import { DndDirective } from '@directives/dnd.directive';
import { TablePaginatorDirective } from '@directives/table-paginator.directive';
import { NumberInputFormatLegacyDirective } from './number-input-format-legacy.directive';

@NgModule({
  declarations: [
    FilterPipe,
    FilterBrandVariantPipe,
    NumberInputLegacyDirective,
    NumberInputQtyLegacyDirective,
    ObserverIntersectionDirective,
    DndDirective,
    NumberInputFormatLegacyDirective,
  ],
  imports: [TablePaginatorDirective],
  exports: [
    FilterPipe,
    FilterBrandVariantPipe,
    NumberInputLegacyDirective,
    NumberInputQtyLegacyDirective,
    ObserverIntersectionDirective,
    DndDirective,
    TablePaginatorDirective, // Re-export for backward compatibility
    NumberInputFormatLegacyDirective,
  ],
})
export class DirectiveModule {}
